var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGithub = function SvgGithub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.531 6.794C6.055 6.794 0 12.849 0 20.325c0 5.988 3.873 11.045 9.252 12.838.677.118.93-.288.93-.643 0-.321-.017-1.387-.017-2.52-3.4.626-4.279-.829-4.55-1.59-.152-.39-.811-1.59-1.386-1.911-.474-.254-1.15-.88-.017-.897 1.065-.017 1.826.981 2.08 1.387 1.218 2.047 3.163 1.472 3.941 1.116.118-.879.474-1.471.863-1.81-3.011-.338-6.157-1.505-6.157-6.68 0-1.472.524-2.69 1.387-3.637-.135-.338-.609-1.725.135-3.586 0 0 1.133-.355 3.721 1.387a12.554 12.554 0 0 1 3.383-.456c1.15 0 2.3.152 3.383.456 2.588-1.759 3.721-1.387 3.721-1.387.744 1.86.27 3.248.135 3.586.863.947 1.387 2.148 1.387 3.637 0 5.192-3.163 6.342-6.173 6.68.49.423.913 1.235.913 2.504 0 1.81-.017 3.264-.017 3.721 0 .355.254.778.93.643a13.553 13.553 0 0 0 9.218-12.838c0-7.476-6.055-13.531-13.53-13.531Z",
    fill: "#000"
  })));
};

export default SvgGithub;